export const Constants = {
  CSS_TRANSITION: `0.4s cubic-bezier(0.5, 0.25, 0, 1)`,
}
